export default class Application {
  constructor() {
    this.tag = "";
  }
}
